//#region Libraries
import styled from "styled-components";
//#endregion
import { TDefContent } from "components/CustomTableList/components/TableListItem/ListItem/styles";

export const Cell = styled(TDefContent)`
    background-color: var(--light-blue-2);
    width: 100%;
    &.small {
        padding: 10px 15px;
    }
    & h5 {
        width: max-content;
        width: 100%;
        text-align: center;
    }
    &.changed h5 {
        font-weight: bold;
    }
`;
export const NameCell = styled(Cell)`
    & h5 {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        min-width: 110px;
        width: 100%;
        max-width: 150px;
    }
`;
export const CapacityCell = styled(Cell)`
    & h5 {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: 70px;
    }
`;
export const AddressReferenceCell = styled(Cell)`
    & h5 {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        min-width: 90px;
        width: 100%;
        max-width: 130px;
    }
`;
export const DetailsCell = styled(Cell)`
    & h5 {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        min-width: 80px;
        width: 100%;
        max-width: 130px;
    }
`;
export const DateCell = styled(Cell)`
    &.small {
        padding-right: 5px;
        padding-left: 5px;
    }
    & h5 {
        padding: 0 5px;
    }
`;